enum NylasFormSyncDirection {
  INCOMING = "incoming",
  OUTGOING = "outgoing",
  TWO_WAY = "two_way",
}

export default NylasFormSyncDirection;
